import type { CompetitionView } from '@ps/isp-web-services-types';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import QuickSwitcher from '../QuickSwitcher/QuickSwitcher';

import { TXTWCL_N0_logo } from './CompetitionCard.messages.json';
import styles from './CompetitionCard.scss';

type Props = Pick<CompetitionView, 'competitionName' | 'logoUrl'>;

const CompetitionCard: React.FC<Props> = ({ competitionName, logoUrl }) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.wrapper}>
      <QuickSwitcher
        title={
          <>
            {logoUrl ? (
              <img src={logoUrl} alt={formatMessage(TXTWCL_N0_logo, { competitionName })} />
            ) : null}
            {competitionName}
          </>
        }
      />
    </div>
  );
};

export { CompetitionCard };
